
export const BASEROUTE = '/';

export const ROUTE_MAIN_PAGE = '/main';
export const ROUTE_LOGIN = '/signin';
export const ROUTE_FORGET_PASSWORD = '/forgetpassword';
export const ROUTE_LOGOUT = '/logout';
export const ROUTE_SIGNUP = '/signup';
export const ROUTE_SIGNUP_INVITATION = '/signup/:hash';
export const ROUTE_SIGNUP_TEMP = '/signup_temp';
export const ROUTE_PROFILE = '/userprofile';
export const ROUTE_EDIT_PROFILE = '/userprofile/edit';
export const ROUTE_SOCIAL_OAUTH = '/social_oauth/:type?';
export const ROUTE_THINK = '/think';
export const ROUTE_CHAT = '/chat/:id';
export const ROUTE_USERS_PROFILES = '/users_profiles/:id';
export const ROUTE_USER_PROFILE = '/user/:id';
export const ROUTE_CANCEL_DELETION_ACCOUNT = '/cancel-deletion';
export const ROUTE_DISCOVER = '/discover';
export const ROUTE_CONNECTIONS = '/connections';
export const ROUTE_CONNECTIONS_SECTION = '/connections/:section';
export const ROUTE_GPDR = '/gpdr';
export const ROUTE_INITIATIVES = '/initiatives';
export const ROUTE_THINK_SEED_CREATION = '/think-chat/creation';
export const ROUTE_THINK_SEED_CREATION_FROM_CALL = '/think-chat/creation/call/:callId';
export const ROUTE_INVITATIONS = '/invitations';
export const ROUTE_THINK_SEED_VIEW = '/think-seed/view/:id';
export const ROUTE_UPGRADE = '/upgrade/:id';
export const ROUTE_THINK_TANK = '/think-tank/:id';
export const ROUTE_THINK_TANKS = '/think-tanks';
export const ROUTE_MESSAGES = '/messages';
export const ROUTE_DELETE_ACCOUNT_SUCCESS = '/deleted-account';
export const ROUTE_NARRATIVE_THINK_CHAT = '/narratives/:id/think-chats/';
export const ROUTE_NARRATIVE_SPEED_DATING = '/narratives/:id/speed-dating/';
export const ROUTE_ZOOM_MEETING = '/zoom-meeting/:id';
export const ROUTE_CALL_FOR_IMPACT = '/call-for-impact/:id';
export const ROUTE_NARRATIVE = '/narratives/:id';
export const ROUTE_ELEMENT = '/elements/:id';
export const ROUTE_NARRATIVE_STEP = '/narratives/:idn/step/:ids';
export const ROUTE_THEME_TABLE = '/theme-table/:id';
export const ROUTE_THEME_TABLE_SECTION = '/theme-table/:id/:section';
export const ROUTE_THEME_TABLE_EDIT = '/think-seed/:id/edit';
export const ROUTE_CALL = '/calls/:id';
export const ROUTE_CALL_HALL = '/calls/:id/hall';
export const ROUTE_CALL_HALL_SECTION = '/calls/:id/hall/:section';
export const ROUTE_CALL_THEME_TABLE = '/calls/:callId/theme-table/:id';
export const ROUTE_IMPERSONATE = '/impersonate/:hash';
export const ROUTE_NO_RECOMMENDATIONS = '/no-recommendations';
export const ROUTE_FINE_SERENDIPITY = '/fine-tune';
export const ROUTE_SPEED_DATING = '/speed-dating/:id';
export const ROUTE_SPEED_DATING_RANDOM = '/speed-dating/:id/random';
export const ROUTE_FEEDBACK_USERS = '/recommendations/users';
export const ROUTE_FEEDBACK_TABLES = '/recommendations/tables';
export const ROUTE_EMBED_MAIN = '/embed/:id';



// WEBPACK FOOTER //
// ./src/constants/urls.js